import { TweenLite } from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';

const portalToggle = document.getElementById('toggle-portals');
const portals = document.querySelectorAll('a[href^="#"]');

if (portals && !portals.isEmpty()) {
    portalToggle.addEventListener('click', e => e.target.setAttribute('aria-enabled', e.target.checked));

    [...portals].map((portal) => {
        portal.addEventListener('click', (e) => {
            if (!portalToggle.checked) {
                e.preventDefault();
            
                TweenLite.to(window, 0.7, { scrollTo: { y: portal.getAttribute('href'), autoKill: false } });
            }
        });
    });
}